import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children, redirectTo = "/login" }) {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    // Save where they wanted to go → good UX after login
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  return children ? children : <Outlet />;
}

export function BookingFlowProtectedRoute() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  // You can make this stricter if you want
  const cameFromBooking = location.state?.from?.pathname?.includes('/booking');

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }


  return <Outlet />;
}